import ApiMsProjectsService from '@/services/ms_projects_service';

export const state = {
    webhooks: [],
};

export const getters = {
    allWebhooks: (state) => state.webhooks,
};

export const actions = {
    async fetchWebhooks({ commit }) {
        try {
            const response = await ApiMsProjectsService.get('/webhooks/?only_active=false');
            commit('setWebhooks', response.data);
        } catch (error) {
            console.error('Error fetching webhooks:', error);
        }
    },

    async createWebhook({ dispatch }, webhook) {
        try {
            const response = await ApiMsProjectsService.post('/webhooks/', webhook);
            dispatch('fetchWebhooks');
            return response;
        } catch (error) {
            console.error('Error creating webhook:', error);
            return error?.response;
        }
    },

    async updateWebhook({ dispatch }, webhook) {
        try {
            const response = await ApiMsProjectsService.put(`/webhooks/${webhook.id}`, webhook);
            dispatch('fetchWebhooks');
            return response;
        } catch (error) {
            console.error('Error updating webhook:', error);
            return error?.response;
        }
    },

    async deleteWebhook({ dispatch }, webhookId) {
        try {
            const response = await ApiMsProjectsService.delete(`/webhooks/${webhookId}`);
            dispatch('fetchWebhooks');
            return response;
        } catch (error) {
            console.error('Error deleting webhook:', error);
            return error.response
        }
    },
};

export const mutations = {
    setWebhooks: (state, webhooks) => (state.webhooks = webhooks),
};
